export const generateCSVContent = (headers, dataRows) => {
    // `?? ''` (não `||`): só null/undefined viram célula vazia. Com `||`, um
    // valor 0 (ex.: "Vídeos assistidos: 0") também caía em '' — a célula saía
    // em branco, indistinguível de um dado ausente.
    const escapeCSV = (value) =>
        `"${(value ?? '').toString().replace(/"/g, '""')}"`;

    const csvHeader = headers.map(escapeCSV).join(',');
    const csvRows = dataRows.map(row =>
        Object.values(row).map(escapeCSV).join(',')
    );

    return `data:text/csv;charset=utf-8,${[csvHeader, ...csvRows].join('\n')}`;
};
